<template>
  <div>
    <relatorio
      :headers="headersRel"
      :dados="relatorio"
      :filtro-config="filtroConfig"
      :exportar-p-d-f="true"
      :exportar-x-l-s-x="true"
      :slots="['item.produtor']"
      @exportarPdf="tipoRelatorioPdf"
      @exportarXlsx="tipoRelatorioXLSX"
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td
          v-if="item.itens && item.itens.length > 0"
          :colspan="headers.length"
        >
          <div>
            <v-simple-table
              dense
              class="mb-5 mt-5"
              style="border: 1px solid lightgrey; max-width: 85%;"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      colspan="9"
                      class="black--text font-weight-black"
                    >
                      Itens do serviço:
                    </th>
                  </tr>
                  <tr>
                    <th>Data</th>
                    <th>Técnico</th>
                    <th>Setor</th>
                    <th>Tipo</th>
                    <th>Item</th>
                    <th class="text-right">
                      Quantidade
                    </th>
                    <th class="text-right">
                      Valor Unitário
                    </th>
                    <th class="text-right">
                      Desconto
                    </th>
                    <th class="text-right">
                      Valor Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(itemRelacionado, index) in relatorioList(item.itens)"
                    :key="itemRelacionado.id || `row-${index}`"
                  >
                    <template>
                      <td
                        v-for="(coluna, idx) in itemRelacionado"
                        :key="`coluna-${idx}`"
                        :class="idx >= 5 ? 'text-right' : ''"
                        :colspan="coluna.colspan || 1"
                        :style="{fontWeight: coluna.style || 'normal'}"
                      >
                        {{ coluna.valor }}
                      </td>
                    </template>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </td>
        <td v-else>
          Nenhum registro encontrado
        </td>
      </template>
      <template v-slot:[`item.produtor`]="{ item }">
        <div>
          {{ item.produtor }} - {{ item.fazenda_nome }}
        </div>
      </template>
    </relatorio>
  </div>
</template>

<script>
  import { currencyFormatter } from '../../utils/formatter'
  import Relatorio from './Relatorio.vue'
  import { BOOTSTRAP_PRODUTOR_RELATORIO } from '@/store/modules/produtores'
  import { BOOTSTRAP_SETOR_RELATORIO } from '@/store/modules/setores'
  import { BOOTSTRAP_TECNICO_RELATORIO } from '@/store/modules/tecnicos'
  import {BOOTSTRAP_FORNECEDOR_RELATORIO} from '@/store/modules/fornecedores'
  import { BOOTSTRAP } from '@/store/modules/relatorio'
  import JsPDF from 'jspdf'
  import moment from 'moment'
  import { mapState } from 'vuex'
  import { mapActions } from 'vuex/dist/vuex.common.js'
  import { TypeProduto } from '../../utils/constants'
  import XLSX from 'xlsx'
  import Swal from 'sweetalert2'

  export default {
    components: {
      Relatorio,
    },
    data () {
      return {
        currencyFormatter,
      }
    },
    computed: {
      ...mapState('relatorio', ['ready', 'relatorio', 'filtrosData']),
      ...mapState('fornecedores', ['ready', 'listFornecedores']),
      ...mapState('produtores', ['ready', 'listProdutores']),
      ...mapState('setores', ['ready', 'setores']),
      ...mapState('tecnicos', ['ready', 'listTecnicos']),
      headersRel () {
        return [
          { align: 'left', sortable: false, text: '', value: 'data-table-expand', width: '40px' },
          { align: 'left', sortable: true, text: 'Produtor/Fazenda', value: 'produtor', width: 'auto' },
          { align: 'left', sortable: true, text: 'CPF/CNPJ', value: 'documento', width: 'auto' },
        ]
      },
      filtroConfig () {
        return [
          {
            filtro: 'fornecedor',
            items: this.listFornecedores,
            itemText: 'nome',
            itemValue: 'id',
            label: 'Selecione uma empresa',
            value: null,
            multiple: false,
          },
          {
            filtro: 'produtor',
            items: this.listProdutores,
            itemText: 'nome',
            itemValue: 'id',
            label: 'Selecione um produtor',
            value: [],
          },
          {
            filtro: 'setor',
            items: this.setores,
            itemText: 'descricao',
            itemValue: 'id',
            label: 'Selecione um setor',
            value: [],
          },
          {
            filtro: 'tecnico',
            items: this.listTecnicos,
            itemText: 'nome',
            itemValue: 'id',
            label: 'Selecione um técnico',
            value: [],
          },
        ]
      },
    },
    mounted () {
      this.BOOTSTRAP_PRODUTOR_RELATORIO()
      this.BOOTSTRAP_SETOR_RELATORIO()
      this.BOOTSTRAP_TECNICO_RELATORIO()
      this.BOOTSTRAP_FORNECEDOR_RELATORIO()
    },
    methods: {
      ...mapActions('produtores', [BOOTSTRAP_PRODUTOR_RELATORIO]),
      ...mapActions('relatorio', [BOOTSTRAP]),
      ...mapActions('setores', [BOOTSTRAP_SETOR_RELATORIO]),
      ...mapActions('tecnicos', [BOOTSTRAP_TECNICO_RELATORIO]),
      ...mapActions('fornecedores', [BOOTSTRAP_FORNECEDOR_RELATORIO]),
      colunasVisiveis (itemRelacionado) {
        return itemRelacionado.filter(coluna => coluna.valor !== undefined)
      },
      relatorioList (itens_produtor) {
        const dados = []
        let totalProdutor = 0
        let currentData = null
        let totalData = 0
        const datas = []
        itens_produtor.forEach((servico, index) => {
          if (index === 0) {
            currentData = servico.data_atendimento
            datas.push(servico.data_atendimento)
          }
          if (servico.data_atendimento !== currentData) {
            dados.push([
              { valor: '', style: 'bold' },
              { valor: '', style: 'bold' },
              { valor: '', style: 'bold' },
              { valor: '', style: 'bold' },
              { valor: '', style: 'bold' },
              { valor: '', style: 'bold' },
              { valor: 'Total Dia', style: 'bold', colspan: 2 },
              { valor: totalData.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'BRL' }), style: 'bold' },
            ])
            datas.push(servico.data_atendimento)
            currentData = servico.data_atendimento
            totalData = 0
          }
          const linhaServico = [
            { valor: moment(servico.data_atendimento).format('DD/MM/YYYY') },
            { valor: servico.tecnico_nome },
            { valor: servico.setor_descricao || '' },
            { valor: TypeProduto.getDescription(servico.tipo) },
            { valor: servico.produto + (servico.item_observacao ? ' - ' + servico.item_observacao : '') },
            { valor: Number(servico.quantidade).toLocaleString('pt-BR') },
            {
              valor: Number(servico.valor_unitario).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'BRL' }),
              style: '',
            },
            {
              valor: Number(servico.valor_desconto).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'BRL' }),
              style: '',
            },
            {
              valor: Number(servico.valor_total).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'BRL' }),
              style: '',
            },
            // {
            //   valor_total: servico.valor_total,
            // },
          ]
          linhaServico.valor_total = parseFloat(servico.valor_total) || 0

          dados.push(linhaServico)

          totalProdutor += parseFloat(servico.valor_total) || 0
          totalData += parseFloat(servico.valor_total) || 0
        })

        if (datas.length !== 1) {
          dados.push([
            { valor: '', style: 'bold' },
            { valor: '', style: 'bold' },
            { valor: '', style: 'bold' },
            { valor: '', style: 'bold' },
            { valor: '', style: 'bold' },
            { valor: '', style: 'bold' },
            { valor: 'Total Dia', style: 'bold', colspan: 2 },
            { valor: totalData.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'BRL' }), style: 'bold' },
          ])
        }
        dados.push([
          { valor: '', style: 'bold' },
          { valor: '', style: 'bold' },
          { valor: '', style: 'bold' },
          { valor: '', style: 'bold' },
          { valor: '', style: 'bold' },
          { valor: '', style: 'bold' },
          { valor: 'Total Produtor', style: 'bold', colspan: 2 },
          { valor: totalProdutor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'BRL' }), style: 'bold' },
        ])

        return dados
      },
      async tipoRelatorioXLSX () {
        Swal.fire({
          title: 'Informe o tipo de relatório',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#183b94',
          cancelButtonColor: '#549ACC',
          confirmButtonText: 'Sintético',
          cancelButtonText: 'Analítico',
          reverseButtons: true,
          focusConfirm: false,
        }).then(resposta => {
          Swal.close()
          if (resposta.isConfirmed) {
            this.exportXlsx('sintetico')
          } else if (resposta.dismiss === Swal.DismissReason.cancel) {
            this.exportXlsx('analitico')
          }
        })
      },
      async exportXlsx (tipoRelatorio) {
        const dados = this.relatorio
        let valor_total_geral = 0

        const wb = XLSX.utils.book_new()
        const ws_data = []
        const merges = []

        if (dados.length > 0) {
          dados.forEach((dado, index) => {

            ws_data.push(['Empresa', dado.empresa || 'Sem empresa'])

            ws_data.push(['Produtor/Fazenda', 'CPF/CNPJ'])
            ws_data.push([`${dado.produtor} - ${dado.fazenda_nome}`, dado.documento])

            if (tipoRelatorio === 'analitico') {
              ws_data.push(['Data', 'Técnico', 'Setor', 'Tipo', 'Item', 'Quantidade', 'Valor Unitário', 'Desconto', 'Valor Total'])

              const itensProcessados = this.relatorioList(dado.itens)
              itensProcessados.forEach(produtor => {
                valor_total_geral += parseFloat(produtor.valor_total) || 0
                const row = []
                let colIndex = 0
                const rowIndex = ws_data.length
                produtor.forEach(cell => {
                  row.push({ v: cell.valor })
                  if (cell.colspan && cell.colspan > 1) {
                    merges.push({
                      s: { r: rowIndex, c: colIndex },
                      e: { r: rowIndex, c: colIndex + cell.colspan - 1 },
                    })
                    for (let i = 1; i < cell.colspan; i++) {
                      row.push({ v: '' })
                    }
                    colIndex += cell.colspan
                  } else {
                    colIndex++
                  }
                })
                ws_data.push(row)
              })
              if (index === this.relatorio.length - 1) {
                ws_data.push([
                  '', '', '', '', '', '', 'Total Geral', '',
                  {
                    colspan: 2,
                    v: `R$ ${currencyFormatter(valor_total_geral.toFixed(2))}`,
                    t: 's',
                    s: { alignment: { horizontal: 'right' } },
                  },
                ])
              }

              ws_data.push(['', '', '', ''])
            } else if (tipoRelatorio === 'sintetico') {
              ws_data.push(['Técnico', 'Quantidade', 'Valor Unitário', 'Desconto', 'Valor Total'])

              const row = []
              let valor_total_produtor = 0

              dado.itens.forEach(item => {
                valor_total_produtor += Number(item.valor_total) || 0
                valor_total_geral += Number(item.valor_total) || 0
                const tecnicoEncontrado = row.findIndex(t =>
                  t.tecnico_nome === item.tecnico_nome && t.produtor_id === dado.produtor_id,
                )
                if (tecnicoEncontrado !== -1) {
                  row[tecnicoEncontrado].quantidade += Number(item.quantidade) || 0
                  row[tecnicoEncontrado].valor_unitario += Number(item.valor_unitario) || 0
                  row[tecnicoEncontrado].valor_desconto += Number(item.valor_desconto) || 0
                  row[tecnicoEncontrado].valor_total += Number(item.valor_total) || 0
                } else {
                  row.push({
                    produtor_id: dado.produtor_id,
                    tecnico_nome: item.tecnico_nome,
                    quantidade: Number(item.quantidade) || 0,
                    valor_unitario: Number(item.valor_unitario) || 0,
                    valor_desconto: Number(item.valor_desconto) || 0,
                    valor_total: Number(item.valor_total) || 0,
                  })
                }
              })
              Object.values(row).forEach(tecnico => {
                const valorUnitarioMedio = tecnico.quantidade > 0 ? tecnico.valor_total / tecnico.quantidade : 0

                ws_data.push([
                  tecnico.tecnico_nome,
                  { v: `R$ ${currencyFormatter(tecnico.quantidade)}`, t: 's', s: { alignment: { horizontal: 'right' } } },
                  { v: `R$ ${currencyFormatter(valorUnitarioMedio, 2)}`, t: 's', s: { alignment: { horizontal: 'right' } } },
                  { v: `R$ ${currencyFormatter(tecnico.valor_desconto, 2)}`, t: 's', s: { alignment: { horizontal: 'right' } } },
                  { v: `R$ ${currencyFormatter(tecnico.valor_total, 2)}`, t: 's', s: { alignment: { horizontal: 'right' } } },
                ])
              })

              ws_data.push([
                '', '', '', 'Total Produtor',
                {
                  v: `R$ ${currencyFormatter(valor_total_produtor, 2)}`,
                  t: 's',
                  s: { alignment: { horizontal: 'right' } },
                },
              ])
              if (index === this.relatorio.length - 1) {
                ws_data.push([
                  '', '', '', 'Total Geral',
                  {
                    v: `R$ ${currencyFormatter(valor_total_geral, 2)}`,
                    t: 's',
                    s: { alignment: { horizontal: 'right' } },
                  },
                ])
              }
              ws_data.push(['', '', '', ''])
            }
          })
        } else {
          ws_data.push(['Empresa'])
          ws_data.push([''])
          ws_data.push(['Produtor/Fazenda', 'CPF/CNPJ', 'Setor'])
          ws_data.push(['', '', ''])
          ws_data.push(['Data', 'Técnico', 'Setor', 'Tipo', 'Item', 'Quantidade', 'Valor Unitário', 'Desconto', 'Valor Total'])
          ws_data.push(['', '', '', '', '', '', '', '', ''])
        }
        const ws = XLSX.utils.aoa_to_sheet(ws_data)

        if (merges.length > 0) {
          ws['!merges'] = merges
        }

        const colWidths = ws_data[0].map((_, colIndex) => {
          return ws_data.reduce((maxWidth, currentRow) => {
            let cellValue = currentRow[colIndex]

            if (cellValue && typeof cellValue === 'object' && cellValue.v !== undefined) {
              cellValue = cellValue.v.toString()
            } else if (cellValue === null || cellValue === undefined) {
              cellValue = ''
            } else {
              cellValue = cellValue.toString()
            }

            const cellWidth = cellValue.length
            return Math.max(maxWidth, cellWidth)
          }, 0)
        })

        ws['!cols'] = colWidths.map(width => ({ wch: Math.min(Math.max(width + 2, 8), 50) }))
        XLSX.utils.book_append_sheet(wb, ws, 'Relatório')
        XLSX.writeFile(wb, 'Relatorio.xlsx')
      },
      async tipoRelatorioPdf () {
        Swal.fire({
          title: 'Informe o tipo de relatório',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#183b94',
          cancelButtonColor: '#549ACC',
          confirmButtonText: 'Sintético',
          cancelButtonText: 'Analítico',
          reverseButtons: true,
          focusConfirm: false,
        }).then(resposta => {
          Swal.close()
          if (resposta.isConfirmed) {
            this.exportPdf('sintetico')
          } else if (resposta.dismiss === Swal.DismissReason.cancel) {
            this.exportPdf('analitico')
          }
        })
      },
      async exportPdf (tipoRelatorio) {
        const dados = this.relatorioList(this.relatorio)
        const relatorioAnalitico = tipoRelatorio === 'analitico'
        let valor_total_geral = 0

        let startY = 24
        let novaPagina = true

        var doc = new JsPDF({
          orientation: 'portrait',
        })

        const docWidth = doc.internal.pageSize.width
        const docHeight = doc.internal.pageSize.height
        const logo = await loadImageAsBase64(window.location.origin + '/img/logo.png')

        const fontSize = 10
        const margin = { left: 10, right: 10, bottom: 10 }
        const dateNow = moment().format('DD/MM/YYYY')
        const horaNow = moment().format('HH:mm:ss')

        function addHeader (name, logo, doc) {
          doc.setDrawColor(0, 0, 0)
          doc.setLineWidth(0.1)
          doc.setFont('helvetica', 'normal')
          doc.setTextColor(0, 0, 0)

          doc.addImage(logo, 'png', 10, 5, 38, 14)
          doc.setFontSize(16)
          doc.text(name, docWidth / 2, 15, { align: 'center' })
          doc.setFontSize(8)
          doc.text(dateNow, docWidth - 10, 15, { align: 'right' })
          doc.text(horaNow, docWidth - 10, 20, { align: 'right' })

          doc.setDrawColor(0, 0, 0)
          doc.setLineWidth(0.1)
          doc.line(margin.left, 23, docWidth - margin.right, 23)

          novaPagina = false
        }

        async function loadImageAsBase64 (url) {
          const response = await fetch(url)
          const blob = await response.blob()
          return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(blob)
          })
        }

        if (relatorioAnalitico) {
          for (let index = 0; index < this.relatorio.length; index++) {
            const itens_produtor = this.relatorioList(this.relatorio[index].itens)
            const produtor = this.relatorio[index]

            if (novaPagina) {
              addHeader('Serviços por produtor', logo, doc)
              startY = 24
            }

            if (!novaPagina) {
              doc.setDrawColor(0, 0, 0)
              doc.setLineWidth(0.1)
              doc.line(margin.left, startY - 1, docWidth - margin.right, startY - 1)
            }
            doc.autoTable({
              theme: 'plain',
              startY: startY + 1,
              margin: { left: margin.left },
              styles: {
                textColor: 20,
                fillColor: [255, 255, 255],
                cellPadding: { top: 0, right: 5, bottom: 0, left: 0 },
                fontSize: 10,
                minCellHeight: 5,
              },
              columnStyles: {
                0: { cellWidth: 'auto', halign: 'left', cellPadding: { left: margin.left } },
                1: { cellWidth: 'auto', halign: 'left', cellPadding: { left: margin.left } },
              },
              body: [
              [{content: `Empresa: ${produtor.empresa || 'Sem empresa'}`, colSpan: 2, styles: { cellPadding: { left: 0 }, cellWidth: 124, overflow: 'ellipsize' } }],
              [
                  { content: `Nome: ${produtor.produtor} - ${produtor.fazenda_nome}`, styles: { cellPadding: { left: 0 }, cellWidth: 124, overflow: 'ellipsize' } },
                  { content: `CPF/CNPJ: ${produtor.documento}` },
                ],
                [
                  { content: `Periodo de ${moment(this.filtrosData.data_inicial).format('DD/MM/YYYY')} até ${moment(this.filtrosData.data_final).format('DD/MM/YYYY')}`, styles: { cellPadding: { left: 0 } } },
                ],
              ],
              willDrawPage: (data) => {
                novaPagina = false
                addHeader('Serviços por produtor', logo, doc)
              },
            })

            const startYItens = doc.previousAutoTable.finalY + 1
            doc.line(margin.left, startYItens, docWidth - margin.right, startYItens)
            doc.setFontSize(12)

            const allTableData = []

            allTableData.push([
              { content: 'Data', styles: { fontStyle: 'bold', lineWidth: { bottom: 0.3, top: 0.3 }, lineColor: [0, 0, 0] } },
              { content: 'Técnico', styles: { fontStyle: 'bold', lineWidth: { bottom: 0.3, top: 0.3 }, lineColor: [0, 0, 0] } },
              { content: 'Setor', styles: { fontStyle: 'bold', lineWidth: { bottom: 0.3, top: 0.3 }, lineColor: [0, 0, 0] } },
              { content: 'Tipo', styles: { fontStyle: 'bold', lineWidth: { bottom: 0.3, top: 0.3 }, lineColor: [0, 0, 0] } },
              { content: 'Item', styles: { fontStyle: 'bold', lineWidth: { bottom: 0.3, top: 0.3 }, lineColor: [0, 0, 0] } },
              { content: 'Qtde.', styles: { fontStyle: 'bold', lineWidth: { bottom: 0.3, top: 0.3 }, lineColor: [0, 0, 0] } },
              { content: 'Vlr. Unit.', styles: { fontStyle: 'bold', lineWidth: { bottom: 0.3, top: 0.3 }, lineColor: [0, 0, 0] } },
              { content: 'Desc.', styles: { fontStyle: 'bold', lineWidth: { bottom: 0.3, top: 0.3 }, lineColor: [0, 0, 0] } },
              { content: 'Vlr. Total', styles: { fontStyle: 'bold', lineWidth: { bottom: 0.3, top: 0.3 }, lineColor: [0, 0, 0] } },
            ])

            itens_produtor.forEach(servico => {
              valor_total_geral += parseFloat(servico.valor_total) || 0
              const tmp_linha = []
              servico.forEach(coluna => {
                if (coluna.style === 'bold') {
                  tmp_linha.push({
                    content: coluna.valor,
                    colSpan: coluna.colspan || 1,
                    styles: {
                      fontStyle: 'bold',
                      halign: 'right',
                      lineWidth: { bottom: 0.3 },
                      lineColor: [0, 0, 0],
                    },
                  })
                  return
                }
                tmp_linha.push({ content: coluna.valor, styles: { fontStyle: coluna.style || 'normal' } })
              })
              allTableData.push(tmp_linha)
            })
            if (index === this.relatorio.length - 1) {
              const linhaTotal = [
                {
                  content: 'Total Geral',
                  colSpan: 7,
                  styles: {
                    fontStyle: 'bold',
                    halign: 'right',
                    lineWidth: { bottom: 0.3 },
                    lineColor: [0, 0, 0],
                  },
                },
                {
                  content: `R$ ${currencyFormatter(valor_total_geral, 2)}`,
                  colSpan: 2,
                  styles: {
                    fontStyle: 'bold',
                    halign: 'right',
                    lineWidth: { bottom: 0.3 },
                    lineColor: [0, 0, 0],
                  },
                },
              ]
              allTableData.push(linhaTotal)
            }
            doc.autoTable({
              theme: 'plain',
              startY: startYItens,
              columnStyles: {
              0: { halign: 'left', cellWidth: 17 },
              1: { halign: 'left', cellWidth: 25, overflow: 'ellipsize' },
              2: { halign: 'left', cellWidth: 18, overflow: 'ellipsize' },
              3: { halign: 'left', cellWidth: 16 },
              4: { halign: 'left', cellWidth: 38, overflow: 'ellipsize' },
              5: { halign: 'right', cellWidth: 12 },
              6: { halign: 'right', cellWidth: 23 },
              7: { halign: 'right', cellWidth: 18 },
              8: { halign: 'right', cellWidth: 23 },
            },
              styles: {
                cellPadding: 1.5,
                halign: 'left',
                fontSize: 7,
                overflow: 'ellipsize',
              },
              body: allTableData,
              willDrawPage: (data) => {
                novaPagina = true

                doc.setDrawColor(0, 0, 0)
                doc.setLineWidth(0.1)
                doc.setTextColor(0, 0, 0)
                addHeader('Serviços por produtor', logo, doc)
                const lineY = 23
                data.settings.margin.top = lineY
              },
              margin: { top: 20, left: 10, right: 10, bottom: 15 },
            })

            if (index < dados.length - 1) {
              doc.addPage()
              novaPagina = true
            }
          }

          const totalPages = doc.internal.getNumberOfPages()
          for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i)
            doc.setFontSize(fontSize - 1)
            doc.text(dateNow, 12, docHeight - 10)
            doc.text('https://app.pioneiros.vet.br', docWidth / 2, docHeight - margin.bottom, { align: 'center' })
            doc.text(`Página ${i} de ${totalPages}`, docWidth - 10, docHeight - 10, { align: 'right' })
          }
          doc.save('Serviços por produtor.pdf')
        } else if (tipoRelatorio === 'sintetico') {
          this.relatorio.forEach((item, index) => {
            const itens_produtor = item.itens || []

            const acumula_dado_tecnico = []

            itens_produtor.forEach(item => {
              valor_total_geral += Number(item.valor_total) || 0
              const quantidade = Number(item.quantidade) || 0
              const valor_unitario = Number(item.valor_unitario) || 0
              const valor_desconto = Number(item.valor_desconto) || 0
              const valor_total = Number(item.valor_total) || 0

              const tecnicoEncontrado = acumula_dado_tecnico.findIndex(tecnico =>
                tecnico.tecnico_nome === item.tecnico_nome,
              )

              if (tecnicoEncontrado !== -1) {
                const tecnico = acumula_dado_tecnico[tecnicoEncontrado]
                tecnico.quantidade = (Number(tecnico.quantidade) || 0) + quantidade
                tecnico.valor_unitario = Math.trunc((((Number(tecnico.valor_total) || 0) + valor_total) / (tecnico.quantidade)) * 100) / 100
                tecnico.valor_desconto = (Number(tecnico.valor_desconto) || 0) + valor_desconto
                tecnico.valor_total = (Number(tecnico.valor_total) || 0) + valor_total
              } else {
                acumula_dado_tecnico.push({
                  tecnico_nome: item.tecnico_nome || '',
                  quantidade: quantidade,
                  valor_unitario: valor_unitario,
                  valor_desconto: valor_desconto,
                  valor_total: valor_total,
                })
              }
            })

            if (novaPagina) {
              addHeader('Serviços por produtor', logo, doc)
              startY = 24
            }

            if (!novaPagina) {
              doc.setDrawColor(0, 0, 0)
              doc.setLineWidth(0.1)
              doc.line(margin.left, startY - 1, docWidth - margin.right, startY - 1)
            }
            doc.autoTable({
              theme: 'plain',
              startY: startY + 1,
              margin: { left: margin.left },
              styles: {
                textColor: 20,
                fillColor: [255, 255, 255],
                cellPadding: { top: 0, right: 5, bottom: 0, left: 0 },
                fontSize: 10,
                minCellHeight: 5,
              },
              columnStyles: {
                0: { cellWidth: 'auto', halign: 'left', cellPadding: { left: margin.left } },
                1: { cellWidth: 'auto', halign: 'left', cellPadding: { left: margin.left } },
              },
              body: [
              [{content: `Empresa: ${item.empresa || 'Sem empresa'}`, colSpan: 2, styles: { cellPadding: { left: 0 }, cellWidth: 124, overflow: 'ellipsize' } }],
              [
                { content: `Nome: ${item.produtor} - ${item.fazenda_nome}`, styles: { cellPadding: { left: 0 }, cellWidth: 124, overflow: 'ellipsize' } },
                  { content: `CPF/CNPJ: ${item.documento}` },
                ],
                [
                  { content: `Periodo de ${moment(this.filtrosData.data_inicial).format('DD/MM/YYYY')} até ${moment(this.filtrosData.data_final).format('DD/MM/YYYY')}`, styles: { cellPadding: { left: 0 } } },
                ],
              ],
              willDrawPage: (data) => {
                novaPagina = false
                addHeader('Serviços por produtor', logo, doc)
              },
            })

            const startYItens = doc.previousAutoTable.finalY + 1
            doc.line(margin.left, startYItens, docWidth - margin.right, startYItens)
            doc.setFontSize(12)

            const tableDataTecnicos = []

            tableDataTecnicos.push([
              {
                content: 'Técnico',
                styles: {
                  fontStyle: 'bold',
                  lineWidth: { bottom: 0.3, top: 0.3 },
                  lineColor: [0, 0, 0],
                  halign: 'left',
                },
              },
              {
                content: 'Quantidade',
                styles: {
                  fontStyle: 'bold',
                  lineWidth: { bottom: 0.3, top: 0.3 },
                  lineColor: [0, 0, 0],
                  halign: 'right',
                },
              },
              {
                content: 'Valor Unitário',
                styles: {
                  fontStyle: 'bold',
                  lineWidth: { bottom: 0.3, top: 0.3 },
                  lineColor: [0, 0, 0],
                  halign: 'right',
                },
              },
              {
                content: 'Desconto',
                styles: {
                  fontStyle: 'bold',
                  lineWidth: { bottom: 0.3, top: 0.3 },
                  lineColor: [0, 0, 0],
                  halign: 'right',
                },
              },
              {
                content: 'Valor Total',
                styles: {
                  fontStyle: 'bold',
                  lineWidth: { bottom: 0.3, top: 0.3 },
                  lineColor: [0, 0, 0],
                  halign: 'right',
                },
              },
            ])

            acumula_dado_tecnico.forEach(tecnico => {
              tableDataTecnicos.push([
                { content: tecnico.tecnico_nome || '', styles: { halign: 'left' } },
                {
                  content: tecnico.quantidade.toFixed(2),
                  styles: { halign: 'right' },
                },
                {
                  content: tecnico.valor_unitario.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }),
                  styles: { halign: 'right' },
                },
                {
                  content: tecnico.valor_desconto.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }),
                  styles: { halign: 'right' },
                },
                {
                  content: tecnico.valor_total.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }),
                  styles: {
                    halign: 'right',
                    fontStyle: 'bold',
                  },
                },
              ])
            })

            const totalValorTotal = acumula_dado_tecnico.reduce((sum, t) => sum + t.valor_total, 0)

            tableDataTecnicos.push([
              {
                content: '',
                colSpan: 1,
                styles: {
                  fontStyle: 'bold',
                  halign: 'left',
                  lineWidth: { bottom: 0.3 },
                  lineColor: [0, 0, 0],
                },
              },
              {
                content: '',
                styles: {
                  fontStyle: 'bold',
                  lineWidth: { bottom: 0.3 },
                  lineColor: [0, 0, 0],
                },
              },
              {
                content: '',
                styles: {
                  fontStyle: 'bold',
                  lineWidth: { bottom: 0.3 },
                  lineColor: [0, 0, 0],
                },
              },
              {
                content: 'Total Produtor',
                styles: {
                  fontStyle: 'bold',
                  halign: 'right',
                  lineWidth: { bottom: 0.3 },
                  lineColor: [0, 0, 0],
                },
              },
              {
                content: totalValorTotal.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }),
                styles: {
                  fontStyle: 'bold',
                  halign: 'right',
                  lineWidth: { bottom: 0.3 },
                  lineColor: [0, 0, 0],
                },
              },
            ])
            if (index === this.relatorio.length - 1) {
              const linhaTotal = [
                {
                  content: 'Total Geral',
                  colSpan: 4,
                  styles: {
                    fontStyle: 'bold',
                    halign: 'right',
                    lineWidth: { bottom: 0.3 },
                    lineColor: [0, 0, 0],
                  },
                },
                {
                  content: `R$ ${currencyFormatter(valor_total_geral, 2)}`,
                  colSpan: 1,
                  styles: {
                    fontStyle: 'bold',
                    halign: 'right',
                    lineWidth: { bottom: 0.3 },
                    lineColor: [0, 0, 0],
                  },
                },
              ]
              tableDataTecnicos.push(linhaTotal)
            }

            doc.autoTable({
              theme: 'plain',
              startY: startYItens,
              columnStyles: {
                0: { halign: 'left', cellWidth: 40 },
                1: { halign: 'left', cellWidth: 34 },
                2: { halign: 'left', cellWidth: 39 },
                3: { halign: 'left', cellWidth: 39 },
                4: { halign: 'left', cellWidth: 39 },
              },
              styles: {
                cellPadding: 2,
                halign: 'left',
                fontSize: 7,
              },
              body: tableDataTecnicos,
              willDrawPage: (data) => {
                novaPagina = true

                doc.setDrawColor(0, 0, 0)
                doc.setLineWidth(0.1)
                doc.setTextColor(0, 0, 0)
                addHeader('Serviços por produtor', logo, doc)
                const lineY = 23
                data.settings.margin.top = lineY
              },
              margin: { top: 20, left: 10, right: 10, bottom: 15 },
            })

            if (index < dados.length - 1) {
              doc.addPage()
              novaPagina = true
            }
          })

          const totalPages = doc.internal.getNumberOfPages()
          for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i)
            doc.setFontSize(fontSize - 1)
            doc.text(dateNow, 12, docHeight - 10)
            doc.text('https://app.pioneiros.vet.br', docWidth / 2, docHeight - margin.bottom, { align: 'center' })
            doc.text(`Página ${i} de ${totalPages}`, docWidth - 10, docHeight - 10, { align: 'right' })
          }

          doc.save('Serviços por produtor.pdf')
        }
      },
    },
  }
</script>
